<template>
  <b-modal
    ref="modal"
    header-bg-variant="primary"
    header-class="text-white"
    no-close-on-backdrop
  >
    <template #modal-header>
      <h3>
        <i class="ifr if-cancel text-danger mr-3"></i
        >{{ $t("errors.token_invalid.headline") }}
      </h3>
    </template>
    <b-row>
      <b-col cols="12">
        <p>
          {{ $t("errors.token_invalid.text") }}
        </p>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-row>
        <b-col cols="12" class="text-center">
          <router-link class="btn btn-secondary" :to="{ name: 'scan' }">
            {{ $t("actions.to_scan") }}
          </router-link>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: "TokenInvalidModal",
    beforeRouteLeave(to, from, next) {
      this.$refs.modal.hide();
      next();
    },
    methods: {
      show() {
        this.$refs.modal.show();
      },
    },
  };
</script>

<style>
</style>
